import { render, staticRenderFns } from "./EmployeeLeavesComponent.vue?vue&type=template&id=0ca61bbd&"
import script from "./EmployeeLeavesComponent.vue?vue&type=script&lang=js&"
export * from "./EmployeeLeavesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports